import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { Split } from "lucide-react";

export function SplitProcedureButton({
  procedureName,
  disabled,
  className,
  onClick,
}: {
  procedureName: string;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-xs"
      disabled={disabled}
      className={cn("size-5 shrink-0 text-muted-foreground", className)}
      aria-label={`Move ${procedureName} to a new step`}
      title="Move to new step"
      onClick={onClick}
    >
      <Split className="size-3" />
    </Button>
  );
}
